module.exports = __webpack_public_path__ + "img/4.160e6edc.jpg";